import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  query,
  where,
  orderBy,
  setDoc,
  serverTimestamp,
} from 'firebase/firestore';
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut as firebaseSignOut,
} from 'firebase/auth';
import { FIREBASE_CONFIG } from '../config';

const app = initializeApp(FIREBASE_CONFIG);
export const db = getFirestore(app);
export const auth = getAuth(app);

// ---- Recipes ----

export function subscribeRecipes(userId, callback, onError) {
  const q = query(
    collection(db, 'recipes'),
    where('userId', '==', userId),
  );
  return onSnapshot(q, (snapshot) => {
    const recipes = snapshot.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (b.createdAt?.toMillis?.() || 0) - (a.createdAt?.toMillis?.() || 0));
    callback(recipes);
  }, (err) => {
    console.error('subscribeRecipes error:', err);
    callback([]);
    if (onError) onError(err);
  });
}

export async function getRecipe(id) {
  const snap = await getDoc(doc(db, 'recipes', id));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

export async function createRecipe(userId, data) {
  const docRef = await addDoc(collection(db, 'recipes'), {
    ...data,
    userId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return docRef.id;
}

export async function updateRecipe(id, data) {
  await updateDoc(doc(db, 'recipes', id), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export async function deleteRecipe(id) {
  await deleteDoc(doc(db, 'recipes', id));
}

// ---- Pantry ----

export function subscribePantry(userId, callback, onError) {
  return onSnapshot(doc(db, 'pantry', userId), (snap) => {
    if (snap.exists()) {
      callback(snap.data());
    } else {
      callback({ userId, items: [] });
    }
  }, (err) => {
    console.error('subscribePantry error:', err);
    callback({ userId, items: [] });
    if (onError) onError(err);
  });
}

export async function savePantry(userId, items) {
  await setDoc(doc(db, 'pantry', userId), {
    userId,
    items,
    updatedAt: serverTimestamp(),
  });
}

// ---- Auth ----

export async function signInWithEmail(email, password) {
  return signInWithEmailAndPassword(auth, email, password);
}

export async function signUpWithEmail(email, password) {
  return createUserWithEmailAndPassword(auth, email, password);
}

export async function signOut() {
  return firebaseSignOut(auth);
}
